export default {
      id: "icon-mapwithpoints-usage",
      viewBox: "0 0 426 422",
      url: __webpack_public_path__ + "icons.svg#icon-mapwithpoints",
      toString: function () {
        return this.url;
      }
    }